import { PartnerModule } from "./../store/modules/partner";
import { ConfigModule } from "@/store/modules/config";
import { ReportModule } from "@/store/modules/report.store";

export function getDefaultPartnerColor() {
  const color =
    ReportModule.partner?.settings?.color || PartnerModule.partner?.settings?.color || ConfigModule.color.primary;
  return color;
}
